import React from "react";
import { ToastContainer } from "react-toastify";
import { SectionMappingEngine } from "../components/CMS/SectionMapping/SectionMappingEngine";

export const SectionMapping = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <SectionMappingEngine />
        </div>
      </div>
    </div>
  );
};
